export default __webpack_public_path__ + "static/media/Facebook.65b455ab.svg";